import styled from 'styled-components';
import { theme } from '../../../../styles/theme';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  height: 44px;
  border-bottom: 1px solid ${theme.colors.border};
  border-left: 1px solid ${theme.colors.border};
  padding-right: 8px;
  padding-left: 8px;
`;

export const ShortcutDayContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const ShortcutDay = styled.div`
  padding: 4px;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    > svg {
      fill: ${theme.colors.mainBlue};
    }
  }
`;
